import Vue from "vue";
import VueRouter from "vue-router";
import LandingPage from '../views/home/Index.vue';
import VueMeta from 'vue-meta'

Vue.use(VueRouter);
Vue.use(VueMeta);


export default new VueRouter({
    mode: "history",
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        };
    },
    routes: [
        {
            path: "/auth",
            component: () => import("../views/auth/AuthLayout.vue"),
            children: [{
                    path: "/on-boarding",
                    name: "on-boarding",
                    component: () => import("../views/on-boarding")
                },
                {
                    path: "/signup/:email?",
                    name: "signup",
                    component: () => import("../views/auth/SignUp.vue")
                },
                {
                    path: "/webinar-registration",
                    name:'Webinar Registration',
                    component: () => import("../views/RegisterWebinar.vue")
                },
                {
                    path: "/login",
                    name: "sign-in",
                    component: () => import("../views/auth/SignIn.vue")
                },
                {
                    path: "/forgot_password",
                    name: "forgot-password",
                    component: () => import("../views/auth/ForgotPassword.vue")
                },
                {
                    path: "/reset_password",
                    name: "reset_password",
                    component: () => import("../views/auth/ResetPassword.vue")
                }
            ]
        },
        {
            path: "/email_verification",
            name: "email_verification",
            component: () => import("../views/auth/EmailVerification.vue")
        },
        {
            path: "/",
            component: LandingPage
        },
        {
            path: "/privacy-policy",
            component: () => import("../views/Privacy.vue")
        },
        {
            path: "/blog-guidelines",
            component: () => import("../views/BlogGuidelines.vue")
        },
        {
            path: "/terms-of-use",
            component: () => import("../views/TermsOfUse.vue")
        },
        {
            path: 'app-v2',
            name: 'app-v2',
            component: () => import("../layouts/NavBarSideBar.vue"),
            children: [
                {
                    path: "/blogs/search",
                    name: 'blogs-search',
                    component: () => import("../views/blogs/PostSearch.vue")
                },
                {
                    path: "/blogs/:slug/edit/",
                    name: "edit-blog",
                    component: () => import("../views/blogs/PostsEditor.vue"),

                },
                {
                    path: "/blogs/create",
                    name: "create-blog",
                    component: () => import("../views/blogs/PostsEditor"),
                },
                {
                    path: "/blogs",
                    name: 'all-blogs',
                    component: () => import("../views/blogs/PostsIndex.vue"),
                },
                {
                    path: "/blogs/popular",
                    name: 'popular-blogs',
                    component: () => import("../views/blogs/PopularPosts.vue"),
                },
                {
                    path: "/blogs/bookmarks",
                    name: 'blogs-bookmarks',
                    component: () => import("../views/blogs/PostsBookmarks.vue"),
                },
                {
                    path: "/blogs/my_blogs",
                    name: 'my-blogs',
                    component: () => import("../views/blogs/MyPosts"),
                },
                {   path: "/blogs/tags",
                    name: 'blogs-tags',
                    component: () => import("../views/blogs/PostsTags.vue"),
                },
                {
                    path: "/home",
                    name: 'home-blogs',
                    component: () => import("../views/dashboard/Home.vue")
                }
            ]
        },
        {
            path: 'app-v2-learning',
            name: 'app-v2-learning',
            component: () => import("../layouts/LearningSideNavBar.vue"),
            children: [
                {
                    path: '/tutors',
                    name: 'tutors',
                    component: () => import('../views/learn/tutors/Index.vue')
                },
                {
                    path: '/questions',
                    component: () => import('../views/question-bank/QuestionBankIndex')
                },
                {
                    path: '/questions/:uuid',
                    component: () => import('../views/question-bank/QuestionsShow')
                },
            ]
        },
        {
            path: '/learning/:grade/:subject/topics',
            component: () => import("../layouts/LearningSideNavBar.vue"),
            children: [
                {
                    path: '/learning',
                    component: () => import('../views/learn/Index.vue'),
                },
                {
                    name: 'subject-topics',
                    path: '/learning/:grade/:subject/topics',
                    component: () => import('../views/learn/subject-topics/Index.vue')
                },
                {
                    name: 'topic-lessons',
                    path: '/learning/:topicId/:subTopicId/lessons',
                    component: () => import('../views/learn/topic-lessons/Index.vue')
                },
                {   name: 'watch-content',
                    path: '/watch/:topicId/:subTopicId/:lessonId',
                    component: () => import('../views/learn/content-player/Index.vue'),
                }
            ]
        },
        {
            path: "/blogs/:slug/",
            name: "blogs-show",
            component: () => import("../views/blogs/PostsShow.vue"),
        },
        {
            path: "/profile",
            component: () => import('../layouts/ProfileLayout.vue'),
            children: [
                {
                    path: "/profile",
                    component: () => import("../views/profile/Index.vue")
                },

                {
                    path: "/documents",
                    component: () => import("../views/profile/Document.vue")
                },
                {
                    path: "/change_password",
                    component: () => import("../views/profile/ChangePassword.vue")
                }
            ]
        },
        {
            path: "/mentors/:uuid",
            component: () => import("../views/profile/mentor/Index.vue")
        },
        {
            path: "/:catchAll(.*)",
            component: () => import("../views/NotFoundPage.vue"),
            name: 'Not-Found-Page'
        }
    ]
})
